import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, Segment } from 'semantic-ui-react';

import { Formatters } from 'Common/Helpers';
import {
  DENOMINATIONS,
  CENT_DENOMINATION_PREFIX,
  DOLLAR_DENOMINATION_PREFIX,
} from 'Common/Components/CashCalculator/constants';
import KeyboardInput from 'PointOfSale/modules/common/component/KeyboardInput';
import { LAYOUT_TYPES } from 'Common/Components/Keyboard/constants';

const centFilter = [DENOMINATIONS.C50.name];
const dollarFilter = [DENOMINATIONS.D100.name, DENOMINATIONS.D50.name];

const denominations = [];

/** Filter denominations for use with AmountCalculator */
denominations.push(
  Object.keys(DENOMINATIONS)
    .filter(key => key[0] === CENT_DENOMINATION_PREFIX)
    .filter(key => !centFilter.includes(key))
);

denominations.push(
  Object.keys(DENOMINATIONS)
    .filter(key => key[0] === DOLLAR_DENOMINATION_PREFIX)
    .filter(key => !dollarFilter.includes(key))
);

class AmountCalculator extends React.Component {
  static propTypes = {
    amountPaid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    calculatorItemClick: PropTypes.func,
    onBackspace: PropTypes.func,
    onClear: PropTypes.func,
  };

  static defaultProps = {
    onBackspace: () => {},
    onClear: () => {},
  };

  state = {
    amountPaidFocused: false,
  };

  onAmountPaidFocus = e => {
    const { onFocus } = this.props;

    this.setState({ amountPaidFocused: true });
    onFocus(e);
  };

  onAmountPaidBlur = e => {
    const { onBlur } = this.props;

    this.setState({ amountPaidFocused: false });
    onBlur(e);
  };

  render() {
    const {
      amountPaid,
      onValueClick,
      onChange,
      onClear,
      onBackspace,
    } = this.props;
    const { amountPaidFocused } = this.state;

    return (
      <Segment className="flex-compact flex items-center justify-center flex-1">
        <Grid
          padded
          columns={4}
          stretched
          className="tighter flex-1 amount-calculator"
        >
          <Grid.Row>
            <Grid.Column width={8}>
              <KeyboardInput
                fluid
                icon="dollar"
                iconPosition="left"
                value={amountPaid}
                onFocus={this.onAmountPaidFocus}
                onChange={onChange}
                onBlur={this.onAmountPaidBlur}
                placeholder={amountPaidFocused ? null : '0.00'}
                layoutType={LAYOUT_TYPES.NUMERIC}
              />
            </Grid.Column>
            <Grid.Column width={4} verticalAlign="middle">
              <Button
                icon="chevron circle left"
                onClick={onBackspace}
                compact
                size="big"
              />
            </Grid.Column>
            <Grid.Column width={4} verticalAlign="middle">
              <Button icon="trash" onClick={onClear} compact size="big" />
            </Grid.Column>
          </Grid.Row>
          {denominations.map((denominationGroup, index) => {
            return (
              <Grid.Row key={index}>
                {denominationGroup.map((key, index) => {
                  const denomination = DENOMINATIONS[key];
                  return (
                    <Grid.Column key={index} width={4} verticalAlign="middle">
                      <Button
                        className="font-semibold"
                        onClick={() => onValueClick(denomination.value)}
                        size="big"
                      >
                        {'$' + Formatters.currency(denomination.value)}
                      </Button>
                    </Grid.Column>
                  );
                })}
              </Grid.Row>
            );
          })}
        </Grid>
      </Segment>
    );
  }
}

export default AmountCalculator;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/component/AmountCalculator.js